// extracted by mini-css-extract-plugin
var _1 = "DlPbh9saf8JfysuXr8ri";
var _2 = "zcufuYPmoomo443f_Ocg";
var _3 = "mtWez_gZSa3wBPYkGQqS";
export { _1 as "child", _2 as "root", _3 as "text" }
